module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_CYSTERNA_40.a1a01795.svg";